import React from 'react';
import type { Step } from 'react-joyride';

import { MoreOutlined } from '@ant-design/icons';
import { Button, Table } from 'antd';
import type { TableColumnType } from 'antd';

const tourTableColumns: TableColumnType<any>[] = [
  {
    className: 'bg-gray-100',
    key: 'action',
    align: 'right' as const,
    render: () => <Button type='text' icon={<MoreOutlined />} shape='circle' />
  }
];

const tourTableData = [{ key: 'sales-row-1' }];

export const productTourSteps: Step[] = [
  {
    target: '#myProductsList',
    content: (
      <div>
        <div>As ações e os detalhes referentes aos seus produtos são encontrados nesse botão no final da linha</div>
        <div className='mt-2'>
          <Table columns={tourTableColumns} dataSource={tourTableData} pagination={false} showHeader={false} />
        </div>
      </div>
    )
  },
  {
    target: '#myNewProductButton',
    content: ' Aqui você consegue criar seu produto de uma maneira fácil e rápida, crie e saia vendendo!'
  }
];
